import { api } from './client'

export const installTriggers = async (opts = { sales_posted_at: 1 }) => {
  const { data } = await api.post('/maintenance/install-triggers', opts)
  return data
}

export const normalizeSales = async (opts = { dry_run: 0 }) => {
  const { data } = await api.post('/maintenance/normalize-sales', opts)
  return data
}

export const seedRetail = async () => {
  const { data } = await api.post('/master/setup/seed-retail')
  return data
}

